import { render, staticRenderFns } from "./DetailSection.vue?vue&type=template&id=e1b8d06a&scoped=true"
import script from "./DetailSection.vue?vue&type=script&lang=js"
export * from "./DetailSection.vue?vue&type=script&lang=js"
import style0 from "./DetailSection.vue?vue&type=style&index=0&id=e1b8d06a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1b8d06a",
  null
  
)

export default component.exports